import { render, staticRenderFns } from "./approval_check_rule_popover.vue?vue&type=template&id=6fb68442"
import script from "./approval_check_rule_popover.vue?vue&type=script&lang=js"
export * from "./approval_check_rule_popover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports